"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
function SvgComponent(props) {
    return React.createElement("svg", Object.assign({ viewBox: "0 0 512 512" }, props),
        React.createElement("path", { d: "M240,240H32V32H240Z" }),
        React.createElement("path", { d: "M480,240H272V32H480Z" }),
        React.createElement("path", { d: "M240,480H32V272H240Z" }),
        React.createElement("path", { d: "M480,480H272V272H480Z" }));
}
exports.default = SvgComponent;
